export enum AppUrls {
    // app pages
    APYS = '/',
    REFERRALS = '/referrals',

    // HL
    HYPERUNIT = 'https://app.hyperunit.xyz/',
    HL_APP = 'https://app.hyperliquid.xyz/join/HYPERMARKETS',
    HL_ECOSYSTEM = 'https://www.hypurr.co/ecosystem-map',

    // fberger
    AUTHOR_X = 'https://x.com/fberger_xyz',
    AUTHOR_TELEGRAM = 'https://t.me/fberger_xyz',
    AUTHOR_WEBSITE = 'https://www.fberger.xyz/',
}

export enum AppThemes {
    LIGHT = 'light',
    DARK = 'dark',
}

export enum MarketsSortedBy {
    SUPPLIED_USD = 'SUPPLIED_USD',
    SUPPLY_APY = 'SUPPLY_APY',
    BORROWED_USD = 'BORROWED_USD',
    BORROW_APY = 'BORROW_APY',
    USAGE = 'USAGE',
}

export enum MarketsSortedByDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}
